import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useTeams() {
  const [teams, setTeams] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.teams.index)
      .then((response) => {
        setTeams(response.data.data);
      });
  }, []);

  return teams;
}
